// Only local resolver paths can be retained through login. The resolver still
// obtains the authorized recipient role and saved instance from the server.
export function isWorkItemOpenPath(path) {
	return typeof path === "string" && /^\/work-items\/\d+\/open(?:[?#].*)?$/.test(path);
}

export function isSessionLaunchPath(path) {
	return typeof path === "string" && (
		path.indexOf("/activity/") === 0 || path.indexOf("/player/") === 0 || isWorkItemOpenPath(path)
	);
}
